const ENROLL_ERROR_MESSAGES = {
  ENROLL_VALIDATION_FAILED: "Los datos del formulario no son válidos.",
  ENROLL_INVALID_COUNTRY: "El país seleccionado no es válido.",
  ENROLL_COUNTRY_NOT_ALLOWED: "El país seleccionado no está disponible para enrolamiento.",
  ENROLL_INVALID_PREFIX: "El prefijo telefónico no es válido.",
  ENROLL_INVALID_REFERENCE: "Los datos enviados no coinciden con el catálogo del sistema.",
  ENROLL_DUPLICATE_RECENT:
    "Ya registramos este número hace poco. Si necesita ayuda, escríbanos a soporte.",
  ENROLL_RATE_LIMITED:
    "Demasiados intentos seguidos. Espere un momento e intente nuevamente.",
  ENROLL_CREATE_FAILED: "No se pudo guardar su registro.",
  ENROLL_TERMS_REQUIRED: "Debe aceptar el consentimiento informado.",
  ENROLL_NETWORK_ERROR: "No se pudo conectar con el servidor.",
  ENROLL_RESPONSE_ERROR: "La respuesta del servidor no fue válida.",
  ENROLL_UNKNOWN: "Ocurrió un error inesperado.",
};

function getSupportEmailMessage() {
  const email =
    process.env.REACT_APP_ENROLL_SUPPORT_EMAIL?.trim() ||
    "vamoscontigolrlatam@iqvia.com";
  return `Escríbanos a ${email}.`;
}

function formatEnrollmentError(errorCode, serverMessage) {
  const base =
    ENROLL_ERROR_MESSAGES[errorCode] ||
    serverMessage ||
    ENROLL_ERROR_MESSAGES.ENROLL_UNKNOWN;
  return `${base} (${errorCode}) ${getSupportEmailMessage()}`;
}

function extractApiError(data) {
  if (!data || typeof data !== "object") {
    return { errorCode: "ENROLL_UNKNOWN" };
  }

  if (typeof data.error_code === "string") {
    return { errorCode: data.error_code, message: data.message };
  }

  if (data.detail && typeof data.detail === "object") {
    if (typeof data.detail.error_code === "string") {
      return {
        errorCode: data.detail.error_code,
        message: data.detail.message,
      };
    }
  }

  if (typeof data.detail === "string") {
    return { errorCode: "ENROLL_UNKNOWN", message: data.detail };
  }

  return { errorCode: "ENROLL_UNKNOWN" };
}

function isPatientCreateResponse(data) {
  return (
    data &&
    typeof data === "object" &&
    typeof data.id === "number" &&
    typeof data.name === "string"
  );
}

export async function submitEnrollment(apiBase, payload) {
  const endpoint = `${apiBase}/psplatam/patients/create`;
  let response;

  try {
    response = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch {
    return {
      ok: false,
      errorCode: "ENROLL_NETWORK_ERROR",
      message: formatEnrollmentError("ENROLL_NETWORK_ERROR"),
    };
  }

  const contentType = response.headers.get("content-type") ?? "";
  if (!contentType.includes("application/json")) {
    const fallbackCode =
      response.status === 429 ? "ENROLL_RATE_LIMITED" : "ENROLL_RESPONSE_ERROR";
    return {
      ok: false,
      errorCode: fallbackCode,
      message: formatEnrollmentError(fallbackCode),
    };
  }

  let data;
  try {
    data = await response.json();
  } catch {
    return {
      ok: false,
      errorCode: "ENROLL_RESPONSE_ERROR",
      message: formatEnrollmentError("ENROLL_RESPONSE_ERROR"),
    };
  }

  if (response.ok && isPatientCreateResponse(data)) {
    return { ok: true, data };
  }

  const { errorCode, message } = extractApiError(data);
  return {
    ok: false,
    errorCode,
    message: formatEnrollmentError(errorCode, message),
  };
}

export const ENROLL_SUCCESS_MESSAGE =
  "Gracias por registrarse. Su información fue guardada correctamente. Nos pondremos en contacto con usted. Si tiene alguna consulta, " +
  getSupportEmailMessage();

export function getEnrollSupportEmailMessage() {
  return getSupportEmailMessage();
}
